import staffFetch from "./staffFetch";
import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";

function StaffMessageReportsPage() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorText, setErrorText] = useState("");

  const loadReports = async () => {
    try {
      setErrorText("");

      const res = await staffFetch(`${API}/staff/message-reports`);
      const data = await res.json();

      const list = Array.isArray(data?.reports)
        ? data.reports
        : Array.isArray(data)
        ? data
        : [];

      setReports(list);

      console.log("✅ Signalements MP chargés:", list.length);
    } catch (err) {
      console.log("❌ Erreur loadReports MP:", err);

      setErrorText(
        "Impossible de charger les signalements MP."
      );

      setReports([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReports();
  }, []);

  const warnUser = async (id) => {
    try {
      await staffFetch(`${API}/staff/message-reports/${id}/warn`, {
        method: "PUT"
      });

      alert("Utilisateur averti");

      loadReports();
    } catch (err) {
      console.log(err);
      alert("Impossible d’avertir");
    }
  };

  const restrictUser = async (id) => {
    try {
      await staffFetch(`${API}/staff/message-reports/${id}/restrict-24h`, {
        method: "PUT"
      });

      alert("Messagerie bloquée 24h");

      loadReports();
    } catch (err) {
      console.log(err);
      alert("Impossible de restreindre");
    }
  };

  const closeReport = async (id) => {
    const ok = window.confirm(
      "Classer ce signalement sans sanction ?"
    );

    if (!ok) return;

    try {
      await staffFetch(`${API}/staff/message-reports/${id}/close`, {
        method: "PUT"
      });

      alert("Signalement classé");

      loadReports();
    } catch (err) {
      console.log(err);
      alert("Impossible de fermer");
    }
  };

  const getProofUrl = (proofUrl) => {
    if (!proofUrl) return null;

    if (proofUrl.startsWith("http")) {
      return proofUrl;
    }

    return `https://live-evo.com${proofUrl}`;
  };

  const getStatusLabel = (status) => {
    if (status === "ouvert") return "Ouvert";
    if (status === "en_cours") return "En cours";
    if (status === "traite") return "Traité";
    if (status === "rejete") return "Classé sans suite";

    return status || "Inconnu";
  };

  const isActionDisabled = (status) => {
    return status === "traite" || status === "rejete";
  };

  return (
    <div
      style={{
        background: "#05070d",
        minHeight: "100vh",
        padding: 16,
        color: "#fff"
      }}
    >
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <button
          onClick={() => {
            window.location.href = "/staff";
          }}
          style={backBtn}
        >
          ← Retour staff
        </button>

        <h1
          style={{
            color: "#fff",
            fontSize: 22,
            marginBottom: 4
          }}
        >
          💌 Signalements messages privés
        </h1>

        <div
          style={{
            color: "#8fa6ad",
            marginBottom: 14
          }}
        >
          {reports.length} signalement(s)
        </div>

        {errorText && (
          <div style={errorBox}>
            {errorText}
          </div>
        )}

        {loading ? (
          <div style={loadingBox}>
            Chargement des signalements MP...
          </div>
        ) : reports.length === 0 ? (
          <div style={emptyBox}>
            Aucun signalement MP pour le moment.
          </div>
        ) : (
          reports.map((item) => {
            const proofImage = getProofUrl(item.proof_url);
            const disabled = isActionDisabled(item.status);

            return (
              <div
                key={item.id}
                style={card}
              >
                <div style={title}>
                  🚨 Signalement MP #{item.id}
                </div>

                <div style={label}>Message :</div>
                <div style={message}>
                  {item.message_text || "Message vide"}
                </div>

                <div style={label}>Utilisateur signalé :</div>

                <div style={value}>
                  {item.reported_pseudo || "Pseudo inconnu"}
                  {" "}
                  (
                  {item.reported_email || "email inconnu"}
                  )
                </div>

                <div style={label}>Signalé par :</div>

                <div style={value}>
                  {item.reporter_pseudo || "Pseudo inconnu"}
                  {" "}
                  (
                  {item.reporter_email || "email inconnu"}
                  )
                </div>

                <div style={label}>Raison :</div>

                <div style={value}>
                  {item.reason || "Non précisée"}
                </div>

                <div style={label}>Statut :</div>

                <div style={status}>
                  {getStatusLabel(item.status)}
                </div>

                {item.staff_action && (
                  <>
                    <div style={label}>Action staff :</div>
                    <div style={value}>{item.staff_action}</div>
                  </>
                )}

                {item.staff_note && (
                  <>
                    <div style={label}>Note staff :</div>
                    <div style={value}>{item.staff_note}</div>
                  </>
                )}

                {proofImage && (
                  <>
                    <div style={label}>
                      Preuve capture écran :
                    </div>

                    <img
                      src={proofImage}
                      alt=""
                      style={proofImageStyle}
                    />
                  </>
                )}

                {!disabled ? (
                  <div style={buttons}>
                    <button
                      onClick={() => warnUser(item.id)}
                      style={btnWarn}
                    >
                      Avertir
                    </button>

                    <button
                      onClick={() => restrictUser(item.id)}
                      style={btnRestrict}
                    >
                      Bloquer 24h
                    </button>

                    <button
                      onClick={() => closeReport(item.id)}
                      style={btnClose}
                    >
                      Fermer
                    </button>
                  </div>
                ) : (
                  <div style={closedText}>
                    Signalement déjà traité.
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

const backBtn = {
  background: "#020b14",
  border: "1px solid #00f2ff",
  padding: 11,
  borderRadius: 12,
  marginBottom: 10,
  color: "#00f2ff",
  fontWeight: "bold",
  width: "100%",
  cursor: "pointer"
};

const errorBox = {
  color: "#ff4d4d",
  background: "#22070a",
  border: "1px solid #ff4d4d",
  padding: 10,
  borderRadius: 10,
  marginBottom: 10
};

const loadingBox = {
  color: "#8fa6ad",
  marginTop: 30,
  textAlign: "center"
};

const emptyBox = {
  color: "#8fa6ad",
  textAlign: "center",
  marginTop: 30
};

const card = {
  background: "#0d111a",
  padding: 15,
  marginBottom: 15,
  borderRadius: 10,
  border: "1px solid #00f2ff"
};

const title = {
  color: "#00f2ff",
  fontSize: 16,
  fontWeight: "bold",
  marginBottom: 10
};

const label = {
  color: "#8fa6ad",
  marginTop: 6
};

const value = {
  color: "#fff"
};

const status = {
  color: "#00f2ff",
  fontWeight: "bold"
};

const message = {
  color: "#ff4d4d",
  marginBottom: 5
};

const proofImageStyle = {
  width: "100%",
  maxHeight: "500px",
  objectFit: "cover",
  borderRadius: 12,
  marginTop: 8,
  border: "1px solid #00f2ff"
};

const buttons = {
  display: "flex",
  gap: 8,
  marginTop: 12,
  flexWrap: "wrap"
};

const btnWarn = {
  background: "#ffaa00",
  padding: 10,
  borderRadius: 8,
  border: "none",
  color: "#000",
  fontWeight: "bold",
  cursor: "pointer"
};

const btnRestrict = {
  background: "#ff2d55",
  padding: 10,
  borderRadius: 8,
  border: "none",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"
};

const btnClose = {
  background: "#00f2ff",
  padding: 10,
  borderRadius: 8,
  border: "none",
  color: "#000",
  fontWeight: "bold",
  cursor: "pointer"
};

const closedText = {
  color: "#8fa6ad",
  marginTop: 12,
  fontStyle: "italic"
};

export default StaffMessageReportsPage;
